module.exports = __webpack_public_path__ + "static/img/bonus_9.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_9.png
// module id = t1h8
// module chunks = 0